import { IPriorityRepositoryResponse } from "@/core/repositories/lookup";
import { LookupRepository } from "@/infrastructure/repositories/lookup";

export class GetPriorityUseCase {
  constructor(private readonly lookupRepository: LookupRepository) {}

  async execute(): Promise<IPriorityRepositoryResponse> {
    return this.lookupRepository.getPriorities();
  }
}
